// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_5t-0";